import axios from 'axios';
import { downloadPdf } from '../../../utils/generatePdf';
import { Dispatch } from 'react';
export const downloadGuestCard = (appointmentId: string, setIsLoading: Dispatch<React.SetStateAction<boolean>>) => {
    return async () => {
        await axios
            .get(`/admin/appointments/chats-kioskImages/${appointmentId}`)
            .then((response) => {
                setIsLoading(false)
                if (response?.status === 200 && response?.data) {
                    downloadPdf(response?.data)
                    setIsLoading(false);
                } else {
                    setIsLoading(false)
                }
            })
            .catch((err) => {
                setIsLoading(false);
            });
    };
};
